import React, { useEffect } from 'react'
import { Link, graphql } from "gatsby"
import Img from 'gatsby-image'
import useMapContextState from "../context/mapContext";
import styled from 'styled-components';

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import BigMap from "../components/BigMap";
import { rhythm } from "../utils/typography"

const TitleWrapper = styled.div`
  h1, h2, h3 {
    margin-top: 0;
  }
`

const StartText = styled.h3`
  line-height: 1.44;
`

const CityTag = styled.span`
  color: red;
  font-weight: bold;
`

function BlogIndex(props) {
  const { data } = props
  const siteTitle = data.site.siteMetadata.title
  const posts = data.allMarkdownRemark.edges
  const homeImage = data.image;
  const { removeFocus } = useMapContextState();

  useEffect(() => {
    removeFocus();
  }, []);

  return (
    <>
      <SEO title="Homepage" />
      <TitleWrapper>
      <h3>Hey 👋, my name is <a href="//www.matthiaswehnert.com">Matthias</a>.</h3>
      <h1>Follow me around!</h1>
      <h2>We're going from <CityTag>Bonn</CityTag> to <CityTag>New York City</CityTag> and back again.</h2>
      </TitleWrapper>
      <Img fluid={homeImage.childImageSharp.fluid} />
      <StartText>
        To start following me just click <Link to="/lets-get-started">here</Link>. Or just select one of the locations from the map 📍 ...
      </StartText>
    </>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    image: file(absolutePath: { regex: "/matthiaslottikarlsson.jpg/" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            longitude
            latitude
          }
        }
      }
    }
  }
`
